import { createUnknownComponentVNode as _$cc, createElementVNode as _$ce, className as _$cn } from 'intact-vue-next';
import { getClassAndStyleForFixed } from './useFixedColumns';
import { get, noop } from 'intact-shared';
import { Button } from '../button';
import { Icon } from '../icon';
import { getTextByChildren } from '../utils';
import { Ellipsis } from '../ellipsis';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    props = _this$get.props,
    rowIndex = _this$get.rowIndex,
    columnIndex = _this$get.columnIndex,
    offset = _this$get.offset,
    data = _this$get.data,
    checkType = _this$get.checkType,
    indent = _this$get.indent,
    grid = _this$get.grid,
    colspan = _this$get.colspan,
    rowspan = _this$get.rowspan,
    onClickArrow = _this$get.onClickArrow,
    hasChildren = _this$get.hasChildren,
    loaded = _this$get.loaded;
  var k = this.config.k;
  var blocks = props.$blocks;
  var children = get(data, props.key);
  if (blocks) {
    var template = blocks.template || blocks.default;
    if (template) {
      children = template(noop, [data, rowIndex]);
    }
  }
  if (props.ellipsis) {
    children = _$cc(Ellipsis, {
      'children': children
    });
  }
  var _getClassAndStyleForF = getClassAndStyleForFixed(props, offset, k, checkType),
    className = _getClassAndStyleForF.className,
    style = _getClassAndStyleForF.style;
  if (columnIndex === 0 && indent) {
    style || (style = {});
    style.paddingLeft = indent + "px";
  }
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-hidden"] = props.hidden, _classNameObj[className] = className, _classNameObj);
  return _$ce(2, 'td', [columnIndex === 0 && hasChildren ? _$cc(Button, {
    'type': 'none',
    'icon': true,
    'circle': true,
    'size': 'mini',
    'className': _$cn(k + "-table-arrow"),
    'ev-click': onClickArrow,
    'disabled': loaded === false,
    'children': loaded !== false ? _$cc(Icon, {
      'className': _$cn(k + "-icon-right"),
      'size': 'small'
    }) : _$cc(Icon, {
      'className': _$cn(k + "-tree-icon ion-load-c"),
      'rotate': true
    })
  }) : undefined, children], 0, _$cn(classNameObj), {
    'style': style,
    'title': getTextByChildren(children),
    'rowspan': rowspan,
    'colspan': colspan
  });
}
;